import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import classNames from 'classnames';
import React, { useContext } from 'react';
import { HeaderStateContext } from '../../context/header-state-context';
import { useHeaderData } from '../../hooks/use-header-data';
import { FirstLevelSideBar } from './components/first-level-sidebar';
import { SecondLevelSidebar } from './components/second-level-sidebar';
import { flattenSideBarGroups, SIDE_BAR_LEVEL } from './helpers/flatten-side-bar-groups';
import styles from './nav-drawer.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NavDrawer = function NavDrawer() {
  var _Object$values$find;

  var _useContext = useContext(HeaderStateContext),
      isNavDrawerOpen = _useContext.isNavDrawerOpen,
      closeNavDrawer = _useContext.closeNavDrawer,
      activeItem = _useContext.activeItem;

  var headerData = useHeaderData();
  var navigation = [[headerData === null || headerData === void 0 ? void 0 : headerData.productNavigation, headerData === null || headerData === void 0 ? void 0 : headerData.solutionsNavigation, headerData === null || headerData === void 0 ? void 0 : headerData.resourcesNavigation, headerData === null || headerData === void 0 ? void 0 : headerData.enterpriseNavigation, headerData === null || headerData === void 0 ? void 0 : headerData.customersLink, headerData === null || headerData === void 0 ? void 0 : headerData.pricingLink], [headerData === null || headerData === void 0 ? void 0 : headerData.contactSalesLink]];
  var showFirstLevel = activeItem === '';
  var secondLevel = (_Object$values$find = Object.values(headerData || {}).find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.title) === activeItem;
  })) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.groups;
  var groups = showFirstLevel ? navigation : secondLevel;
  var sideBarGroups = flattenSideBarGroups(groups, showFirstLevel ? SIDE_BAR_LEVEL.FIRST : SIDE_BAR_LEVEL.SECOND);
  return /*#__PURE__*/_jsxs("nav", {
    className: classNames(styles.drawer, 'text-black d-xl-none', _defineProperty({}, styles.open, isNavDrawerOpen)),
    "data-testid": "header-top-nav-mobile",
    children: [/*#__PURE__*/_jsx("div", {
      className: "".concat(styles.overlay, " position-fixed top-0 start-0 w-100 h-100"),
      onClick: closeNavDrawer
    }), /*#__PURE__*/_jsx(FirstLevelSideBar, {
      sideBarGroups: sideBarGroups,
      showFirstLevel: showFirstLevel
    }), /*#__PURE__*/_jsx(SecondLevelSidebar, {
      sideBarGroups: sideBarGroups,
      showFirstLevel: showFirstLevel,
      title: activeItem
    })]
  });
};